import { useRef } from "react";
import { Button } from "@/components/ui/button";
import { FileText, UploadCloud, Trash2 } from "lucide-react";
import { toast } from "sonner";

export const InvoiceCell = ({ api, row, uploadUrl, extra = {}, onDone }) => {
  const ref = useRef(null);
  const err = (e) => toast.error(e.response?.data?.detail || "Errore");
  const tid = `${row.reseller_id}-${row.period}-${row.id}`;
  const open = async () => {
    const w = window.open("", "_blank");
    try {
      const r = await api.get(`/files/${row.invoice.id}/download`, { responseType: "blob" });
      w.location.href = URL.createObjectURL(r.data);
    } catch (e) { w?.close(); err(e); onDone(); }
  };
  const upload = async (file) => {
    const fd = new FormData();
    Object.entries({ ...extra, period: row.period }).forEach(([k, v]) => fd.append(k, v));
    fd.append("file", file);
    try { await api.post(uploadUrl, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success(`Fattura del mese ${row.period} caricata`); onDone(); } catch (e) { err(e); }
  };
  const remove = async () => {
    if (!window.confirm(`Rimuovere la fattura del mese ${row.period}?`)) return;
    try { await api.delete(`/commission-invoices/${row.invoice.id}`); toast.success("Fattura rimossa"); onDone(); } catch (e) { err(e); }
  };
  return (
    <div className="flex items-center gap-1 whitespace-nowrap">
      <input ref={ref} type="file" accept="application/pdf,image/png,image/jpeg,image/webp" className="hidden"
             onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) upload(f); }} data-testid={`invoice-input-${tid}`} />
      {row.invoice ? (
        <>
          <Button variant="ghost" size="sm" onClick={open} title={`${row.invoice.filename || ""} — caricata da ${row.invoice.uploaded_by === "admin" ? "GoWeb" : "rivenditore"}`} data-testid={`invoice-open-${tid}`}><FileText size={14} className="mr-1" /> Fattura</Button>
          <Button variant="ghost" size="sm" onClick={() => ref.current?.click()} title="Sostituisci" data-testid={`invoice-replace-${tid}`}><UploadCloud size={14} /></Button>
          <Button variant="ghost" size="sm" onClick={remove} title="Rimuovi" data-testid={`invoice-delete-${tid}`}><Trash2 size={14} className="text-rose-700" /></Button>
        </>
      ) : (
        <Button variant="outline" size="sm" onClick={() => ref.current?.click()} data-testid={`invoice-upload-${tid}`}><UploadCloud size={14} className="mr-1" /> Allega</Button>
      )}
    </div>
  );
};
